import gql from "graphql-tag";

export const LOGIN = gql`
  mutation($email: String!, $password: String!) {
    tokenAuth(username: $email, password: $password) {
      token
    }
  }
`;
